import { AddRounded, DeleteRounded } from "@mui/icons-material";
import { Box, Button, Dialog, DialogActions, Stack, Typography } from "@mui/material";
import { useState } from "react";
import { grey } from "@mui/material/colors";
import styled from "@emotion/styled";
import { GlobalState } from "context/GlobalContext";
import { AuthState } from "context/AuthContext";
import { attrValAssocObj } from "components/PimDashboard/DashboardComponents/Designer/DesignerAttributes/data";
import RenderInputField from "components/PimDashboard/CommonComponents/RenderInputField/RenderInputField";
import { PimDashboardState } from "context/PimDashboardContext";
import { removeDropdownOptionsBasedonDependency } from "components/PimDashboard/DashboardComponents/Designer/CreateStyle/RenderAttributes/RenderAttributeInputs";

const AddNewModal = ({ modalOpen, setModalOpen, columns, submitFunction }) => {
	const VisuallyHiddenInput = styled("input")({
		clip: "rect(0 0 0 0)",
		clipPath: "inset(50%)",
		height: 1,
		overflow: "hidden",
		position: "absolute",
		bottom: 0,
		left: 0,
		whiteSpace: "nowrap",
		width: 1,
	});

	const [newRow, setNewRow] = useState({});
	const user = AuthState();
	const { setSnackBar, snackBar, setSnackBarOpen } = GlobalState();
	const { selectedStyle, allAttributes } = PimDashboardState();

	const handleCloseModal = () => {
		setModalOpen(false);
	};
	const handleFormSubmit = async (e) => {
		e.preventDefault();
		if (typeof submitFunction === "function") {
			const res = await submitFunction(newRow);
			if (res) handleCloseModal();
		}
	};
	return (
		<Dialog fullWidth maxWidth="md" open={modalOpen} onClose={handleCloseModal} component="form" onSubmit={handleFormSubmit}>
			<Box width="95%" margin="auto" pt={2} display="flex" flexWrap="wrap" columnGap={2} justifyContent="space-around">
				<Typography width="100%" variant="h6">
					Add Color
				</Typography>
				<Stack direction="row" spacing={"3%"} width="100%" display="flex" justifyContent="space-between">
					<Box
						component="label"
						width="120px"
						height="140px"
						border={`1px solid ${grey[200]}`}
						display="flex"
						alignItems="center"
						justifyContent="center"
						overflow="hidden"
						position="relative">
						{newRow?.url ? <img src={newRow.url} style={{ width: "100%", position: "absolute" }} /> : <AddRounded />}

						<VisuallyHiddenInput
							type="file"
							onChange={(e) =>
								setNewRow({ ...newRow, file: e.target.files[0], url: URL.createObjectURL(e.target.files[0]) })
							}
						/>
					</Box>
					<Box flex={1} display="flex" columnGap="2%">
						{columns?.map((column) => {
							let options = {};
							options = removeDropdownOptionsBasedonDependency(
								column,
								selectedStyle,
								column?.[attrValAssocObj],
								allAttributes
							);
							return (
								<RenderInputField
									column={{ ...column, options }}
									data={newRow}
									setData={setNewRow}
									selectOptObjName={"options"}
									width={"45%"}
									// dependencyColData={}
								/>
							);
						})}
					</Box>
				</Stack>
			</Box>

			<DialogActions>
				<Button variant="outlined" onClick={handleCloseModal}>
					Cancel
				</Button>
				<Button autoFocus variant="contained" sx={{ mr: 1 }} type="submit">
					Add
				</Button>
			</DialogActions>
		</Dialog>
	);
};

export default AddNewModal;
